<template>
  <div class="md-layout md-layout-item">
    <div class="md-card rounded-extreme">
      <div class="md-layout md-layout-item event-container">
        <div class="md-layout-item md-size-100">
          <h3 class="title md-layout-item md-size-100 text-primary bold">{{ item.description.title }}</h3>
        </div>

        <div class="md-layout-item md-size-100 event-image">
          <img :src="imgUrl" @error="imgNotLoaded"/>
        </div>

        <div class="md-layout-item md-size-100 event-details-container">
          <div class="bold text-gray">{{ $t('Opening') }}</div>
          <md-icon class="text-primary regular">schedule</md-icon>
          <span
              class="text-gray regular"
          >{{ item.startDate | moment("YYYY-MM-DD") }}, {{ item.startDate | moment("HH:mm") }}</span>
          <br/>
          <div class="text-gray bold" style="margin-top:12px">{{ $t('Ending') }}</div>
          <md-icon class="text-primary regular">schedule</md-icon>
          <span
              class="text-gray regular"
          >{{ item.endDate | moment("YYYY-MM-DD") }}, {{ item.endDate | moment("HH:mm") }}</span>
          <br/>
          <template v-if="item.roomCode">
            <div class="bold text-gray">{{ $t('Room') }}</div>
            <md-icon class="text-primary regular">location_on</md-icon>
            <span
                class="text-gray regular"
            >{{ $t('RoomLabel') }} {{ item.roomCode }}</span>
            <br/>
          </template>
          <div class="event-details">
            <span
                class="event-state text-primary bold"
                v-if="getEventState(item) === state.INCOMING"
            >{{ $t(state.INCOMING) }}</span>
            <span
                class="event-state current bold"
                v-if="getEventState(item) === state.CURRENT"
            >{{ $t(state.CURRENT) }}</span>

            <div>
              <div class="md-layout md-alignment-center-center">
                <div class="md-layout-item">
                  <span
                      class="event-state ended bold"
                      v-if="getEventState(item) === state.ENDED"
                  >{{ $t(state.ENDED) }}</span>
                </div>
                <div class="md-layout-item">
                  <md-button
                      v-if="item.roomId"
                      @click.prevent="$emit('showOnMap')"
                      class="md-round md-primary md-sm md-blue-border"
                  >{{ $t('Map') }}
                  </md-button>
                </div>
                <div class="md-layout-item">
                  <md-button
                      @click.prevent="$emit('showDetails')"
                      class="md-round md-primary md-sm md-blue-border"
                  >{{ $t('Show details') }}
                  </md-button>
                </div>
              </div>
            </div>
            <div>


            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import axios from "@/util/axios";

export default {
  props: ["item"],
  computed: {
    ...mapGetters({
      conference: "conference/current",
      language: "language/current"
    }),
    description() {
      return this.item.description;
    },
    imgUrl() {
      return axios.getFileUrl(this.item.description.pictureFileId);
    }
  },
  data() {
    return {
      shadowNormal: {
        type: Boolean,
        default: false
      },
      noColoredShadow: {
        type: Boolean,
        default: false
      },
      imgLoaded: false,
      state: {
        INCOMING: "Incoming",
        CURRENT: "Current",
        ENDED: "Ended"
      }
    };
  },
  methods: {
    imgNotLoaded(event) {
      if (!this.imgLoaded) {
        event.target.src = require("@/assets/img/cultural-event-placeholder.jpg");
      }
      this.imgLoaded = true;
    },
    getEventState(item) {
      let today = Date.now();
      let start = new Date(item.startDate);
      let end = new Date(item.endDate);

      if (end.valueOf() < today) {
        //past
        return this.state.ENDED;
      } else if (end.valueOf() > today && start.valueOf() > today) {
        //future
        return this.state.INCOMING;
      }
      return this.state.CURRENT; //current
    }
  }
};
</script>

<style lang="scss" scoped>
.justify-content-center {
  justify-content: center !important;
}

.md-card {
  box-shadow: 0px 0px 30px #00000019;
}

.ended {
  color: red;
}

.current {
  color: green;
}

.md-icon {
  margin-left: 0px !important;
}

h3 {
  margin-top: 10px !important;
}

.event-details {
  margin-top: 16px;
  vertical-align: text-top;
}

.event-details-container {
  margin-top: 24px;
  align-self: flex-end;
}

.event-image {
  align-self: center;
  margin-top: 12px;
}

.event-container {
  padding: 10px 20px 20px 20px;
}
</style>



